import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@/components/ui/accordion';
import { TID } from '@/constants/testIds';
import { FAQS } from '@/constants/content';

export default function FAQ() {
    return (
        <section id="faq" className="section-pad bg-soft">
            <div className="container-wl grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                <div className="lg:col-span-5 lg:sticky lg:top-28">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="gold-rule" />
                        <span className="overline">Frequently Asked</span>
                    </div>
                    <h2 className="font-display-bold text-ink text-4xl lg:text-[52px] leading-[1.05] tracking-tight">
                        Questions our clients ask <span className="italic text-gold-600">most often.</span>
                    </h2>
                    <p className="mt-5 text-ink/65 text-[16px] leading-relaxed">
                        Don’t see what you are looking for? Reach out — a quick conversation is often
                        the fastest answer.
                    </p>
                </div>

                <div className="lg:col-span-7">
                    <Accordion type="single" collapsible className="space-y-3">
                        {FAQS.map((f) => (
                            <AccordionItem
                                key={f.id}
                                value={f.id}
                                data-testid={TID.faqItem(f.id)}
                                className="bg-white border border-hairline rounded-xl px-6 data-[state=open]:shadow-soft"
                            >
                                <AccordionTrigger className="text-left font-display-bold text-ink text-[18px] hover:no-underline py-5">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-ink/70 text-[15px] leading-relaxed pb-6">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
